<template src='./financialMovement.pug' lang='pug'></template>

<script>
import GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import { generateFinMovFromRow } from '../../../../utils/transformationData.js'
import closeModal from '../../../../events/closeModal'
import FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'

export default {
  name: 'FinancialMovement',

  components: {
    GridDetailsModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    InputEstablishment,
    TreeGrid
  },

  data () {
    return {
      establishimentsUrls: {
        establishments: 'financialMovements/establishment/list',
        attributes: '/financialMovements/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      gridId: '#MovimentoFinanceiro',
      treeGridCfg: {},
      audit: {},
      dateRange: {},
      situationList: [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto'),
          checked: true
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado'),
          checked: true
        },
        {
          id: 'M',
          nome: this.$t('statusConciliacao.conciliadoManualmente'),
          checked: true
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente'),
          checked: true
        },
        {
          id: 'N',
          nome: this.$t('statusConciliacao.naoAplicavel'),
          checked: true
        }
      ],
      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'MovimentosFinanceiros',
      dataTableColumns: [],
      disableSearchButton: false,
      detailsObj: {
        establishtmentValue: {},
        mainValuesList: [],
        monetaryValuesList: [],
        statusValuesList: [],
        integrationValuesList: [],
        idProcessamento: -1
      },
      finMovGridModalId: '',
      isOpenDetailsModal: false,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTimePlan: true,
      firstTimeEstableshment: true,
      modalDetailsTabs: [],
      attList: [],
      filterable: [],
      columnsFilterable: [],
      showCustomColumns: false,
      isExportFile: false
    }
  },

  computed: {
    idsFilterEstablishments () {
      return this.$store.getters.idsFilterEstablishments
    }
  },

  watch: {
    situationList: {
      handler (val) {
        this.selectedStatuses = []
        val.forEach(st => {
          if (st.checked) {
            this.selectedStatuses.push(st.id)
          }
        })
      },
      deep: true
    }
  },

  methods: {
    resetFilter () {
      this.selectedEstablishments = []
      this.situationList.forEach(situation => {
        situation.checked = true
      })
    },

    getLoadingMessages () {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']
    },

    validate () {
      let self = this
      let promise = null
      return new Promise(resolve => {
        self.$validator.validateAll().then((result) => {
          if (result && self.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download()
            } else {
              self.showTreegrid = true
              startTreeGridLoading(self.gridId, self.getLoadingMessages())
              promise = self.search()
            }
            promise.finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    mountFilters () {
      this.disableSearchButton = true
      let filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsPlanosConciliacao: [],
        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),
        situacoesConciliacao: this.selectedStatuses,
        lang: language.getCookieByName('language')
      }

      return filter
    },

    download () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchFinancialMovementsToFile', { filter: this.mountFilters() })
        .then(() => {
          this.disableSearchButton = false
          resolve()
        }).catch((error) => {
          this.error = true
          this.msgError = error.body
          this.$root.$refs.notification.error('GENERAL')
          this.disableSearchButton = false
          reject()
        })
      })
    },

    search () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchFinancialMovements', { filter: this.mountFilters() })
          .then((response) => {
            if (window.Grids[0]) {
              window.DisposeGrids()
            }
            this.result = response.data
            this.treeGridCfg = response.data.Cfg.Layout
            window.Grids.abrirModalDetalhes = (row) => {
              this.finMovGridModalId = 'finMovGridModalIdMov-' + row.IdMovimentacao
              trackAnalyticsEvent(this, 'row-click', 'movimento-financeiro-grid-details', row.IdMovimentacao)
              this.detailsObj = generateFinMovFromRow(row)
              this.detailsObj.statusLancamento = row.SituacaoConciliacao
              this.generateModalTabs()
              setTimeout(() => {
                this.showDetailsModal()
                window.Grids[0].Disable()
              }, 100)
            }
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            resolve()
          }).catch((error) => {
            this.$root.$refs.notification.error(error)
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    },

    showDetailsModal () {
      this.isOpenDetailsModal = true
    },

    closeDetailsModal () {
      this.isOpenDetailsModal = false
    },

    generateModalTabs () {
      let tabs = []
      // push tab details
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          establishtmentValue: this.detailsObj.establishtmentValue,
          mainValuesList: this.detailsObj.mainValuesList,
          statusValuesList: this.detailsObj.statusValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList,
          commentary: this.detailsObj.commentary
        }
      })

      if (this.detailsObj.idProcessamento) {
        // push tab details
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            establishtmentValue: this.detailsObj.establishtmentValue,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        })
      }

      // push tab historic
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.findFinancialMovementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value
        }
      })

      // push tab allotment
      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabAllotment',
        idTabContent: 'tab-allotment-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadAllotmentGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabLote'),
        icon: 'tab-icon-font fa fa-cubes',
        type: 'TabAllotment',
        props: {
          getAllotment: this.findFinancialMovementAllotment,
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tipoMovimento: 'MovFin'
        }
      })

      // push tab tasks
      tabs.push({
        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tipoMovimento: 'MovFin',
          statusMovimento: this.detailsObj.statusLancamento
        }
      })
      this.modalDetailsTabs = tabs
    },

    findFinancialMovementHistory (id) {
      let data = {
        idFinancialMovement: id,
        url: '/financialMovements/history'
      }
      return this.$store.dispatch('getHistoricFinancialMovement', data)
    },

    findFinancialMovementAllotment (id) {
      let data = {
        idFinancialMovement: id,
        url: '/financialMovements/getAllotmentByMovFinId'
      }
      return this.$store.dispatch('getAllotmentByMovementId', data)
    },

    findIntegration (id) {
      let data = {
        idProcessamento: id,
        url: '/processedFiles/getProcessedFilesById'
      }
      return this.$store.dispatch('getProcessedFiles', data)
    }
  },

  mounted () {
    // Listener para evento de atualização de dados dentro da modal de detalhes,
    // o que requer uma nova consulta para o relatório
    const self = this
    closeModal.$on('modalDetaisClose', (flag) => {
      if (flag) {
        self.showTreegrid = true
        startTreeGridLoading(self.gridId, self.getLoadingMessages())
        self.search()
        // Altera a flag que recarrega a treegrid após o recarregamento
        // para impedir que ela seja recarregada sempre após a primeira vez
        closeModal.$emit('taskChange', false)
      }
    })
  }
}
</script>

<style>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search {
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}

.checkbox {
  margin-top: 0px;
  margin-bottom: 0px;
}

.func-group-labels {
  color: #515151;
  font-size: 13px !important;
  text-transform: initial !important;
  font-weight: normal !important;
  padding-top: 1px;
}

.status-filter {
  margin-right: 3vw;
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// FinancialMovement.vue?6d6e7631